export default __webpack_public_path__ + "images/language-english.svg";